export const RATING_QUESTION =
  'Less qualified people got promoted. They just communicated better.'

export const RATING_OPTIONS = [1, 2, 3, 4, 5] as const
